import React from "react";
import { Section } from "../pages/Collection";
import collectionBaner from "../assets/images/collection/collection-baner.jpg";
import { Container, Typography } from "@mui/material";
import Address from "../components/Address";
import { Helmet } from "react-helmet";
const Contact = () => {
  return (
    <div>
      <Helmet title="contact" />
      <Section img={collectionBaner}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat,sans-serif",
            fontWeight: 600,
            color: "white",
            zIndex: 10,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          Contact
        </Typography>
      </Section>
      <div style={{ margin: "10px" }}>
        <Address />
      </div>
    </div>
  );
};

export default Contact;
